import React from "react";

/**
 * DetailCard
 * Standard card layout for entity summaries (e.g. leaderboard rows, user/org stats).
 * Shows a title and a vertical list of label/value pairs.
 */
function DetailCard({ title, badge, rows = [], className = "" }) {
	return (
		<div className={`rounded-2xl border border-slate-200 bg-white shadow-sm p-4 md:p-4.5 ${className}`}>
			<div className="flex items-center justify-between mb-4">
				{title && <h4 className="text-sm font-semibold text-slate-900 md:text-base">{title}</h4>}
				{badge && <div className="px-2 py-0.5 text-xs font-medium rounded-full bg-primary/5 text-primary">{badge}</div>}
			</div>
			<div className="space-y-2.5 text-sm">
				{rows.map(({ label, value, key }) => (
					<div key={key || label} className="flex items-start justify-between gap-4">
						{label && <div className="mt-0.5 text-xs text-secondary min-w-[6rem]">{label}</div>}
						<div className="flex-1 text-sm font-semibold text-slate-900 text-right">{value}</div>
					</div>
				))}
			</div>
		</div>
	);
}

export default DetailCard;

